import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getCopClientAssignments = api(async function copClientAssignments({
    codeOfPracticeId,
    searchTerm,
    skip,
    take,
}) {
    return query(
        gql`
            query CopClientAssignments($codeOfPracticeId: ID!, $searchTerm: String, $skip: Int, $take: Int) {
                copClientAssignments(
                    codeOfPracticeId: $codeOfPracticeId
                    searchTerm: $searchTerm
                    skip: $skip
                    take: $take
                )
            }
        `,
        { codeOfPracticeId, searchTerm, skip, take },
        { returns: "copClientAssignments" }
    )
})
